var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',[_c('b-select',{attrs:{"value":_vm.value,"placeholder":"Registros por página"},on:{"input":val => _vm.$emit('input', val)}},_vm._l((_vm.items),function(item){return _c('option',{domProps:{"value":item}},[_vm._v(" "+_vm._s(item)+" por página ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }